import Vue from 'vue'

Vue.filter('formatMoney', function (val) {
    if(val === null) {
        val = 0
    }
    // var x=val;
    // x= parseInt(x)
    // x=x.toString();
    // var lastThree = x.substring(x.length-3);
    // var otherNumbers = x.substring(0,x.length-3);
    // if(otherNumbers != '')
    //     lastThree = ',' + lastThree;
    // var res = otherNumbers.replace(/\B(?=(\d{2})+(?!\d))/g, ",") + lastThree;
    let res =  new Intl.NumberFormat('en-IN').format(val)
   return `₹ ${res}` 
  })
  